import { useEffect, useState } from 'react';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AccordionStyled, NothingParcelament, List } from './InstallmentMeans.styles';
import { compare } from '../../../../utils/order/compare';
import ProductInformation from '../components/ProductInformation.component';

export default function InstallmentMeans({ options, product }: any) {

  const [buyOptions, setBuyOptions] = useState<any[]>([]);

  useEffect(() => {
    let newOptions: any[] = [];

    options.map((item: any) =>
      newOptions.push(item.dadosDinamica)
    );
    setBuyOptions(newOptions.sort((a: any, b: any) => compare(a, b, 'quantidadeDeParcelas')));
  }, [options]);

  const produtosEletronico = buyOptions.filter((value: any) => !!value.planoPagamento);

  const calcPortion = (price: string, n: number): string => (parseFloat(price) / n).toFixed(2);
  const choiceInfo = (taxa: number): string => (taxa > 0 ? "com juros" : "sem juros");

  const toApplyCompoundInterest = (valorFinanciado: number, parcelas: number, juros: number) => {
    let cf = juros / (1 - (1 / Math.pow(1 + juros, parcelas)));
    let valorDaParcela = cf * valorFinanciado;

    return valorDaParcela * parcelas;
  }

  const generatePortion = (
    data: any,
    index: number,
    options: any[]
  ): React.ReactElement[] => {
    let listElements: React.ReactElement[] = [];
    let portionMin: number = 0;

    portionMin = index ? options[index - 1].quantidadeDeParcelas + 1 : 2;

    const price = Number(product?.VIGENTE) || data.valorAVista;

    for (let i: number = portionMin; i <= data.quantidadeDeParcelas; i++) {

      let currentPrice = (data.taxa > 0 ? toApplyCompoundInterest(price, i, data.taxa / 100).toFixed(2) : price.toFixed(2))

      listElements.push(
        <li key={`portion-${i}-${data.quantidadeDeParcelas}x`}>
          R${currentPrice} em {i}x de R${calcPortion(currentPrice, i)} {choiceInfo(data.taxa)}
        </li>
      );
    }

    return listElements;
  };

  if (!produtosEletronico.length) {
    return <NothingParcelament>Somente disponível pagamento à vista.</NothingParcelament>
  }

  return (
    <>
      <ProductInformation title='' titleTooltip='Planos identificados com CTSF são exclusivos para o cartão Cencosud.' value={''} />
      {produtosEletronico.map((option: any, index: number, options: any[]) => (
        <AccordionStyled key={index}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>{`${option.planoPagamento} ${(option.taxa > 0) ? `(${option.taxa}%)` : ""}`}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List>
              {generatePortion(option, index, options)}
            </List>
          </AccordionDetails>
        </AccordionStyled>
      ))}
    </>
  );
}
